import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=2bd48f8b"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports